"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFRAME_EVENTS = void 0;
exports.IFRAME_EVENTS = {
    IFRAME_INIT: 'IFRAME_INIT'
};
